import React from 'react'

const AddTermsAndConditions = () => {
  return (
    <div>
      
    </div>
  )
}

export default AddTermsAndConditions
